'use client'

import DisablePrefetchLink from '@component/disablePrefetchLink'
import IconReview from '@icon/agent/review.svg'
import { useSigninVerify } from '@hooks/useLogin'
import getRouter, { URLS, getRouterHref } from '@router'
import useProgressRouter from '@hooks/useProgressRouter'

export function ReviewButton({
  data
}) {

  const { pushRouter } = useProgressRouter()
  const loginVerify = useSigninVerify(() => {
    pushRouter(getRouterHref(URLS.agentReview, { slug: data.slug }))
  }, 'Agent_Review')
  return (
    <DisablePrefetchLink href={getRouter(URLS.agentReview, { slug: data.slug })} className='w-full px-30 button-primary-out' onClick={loginVerify} data-noprogress>
      <IconReview width={16} height={16} fill='var(--color-theme)'></IconReview>
      <span className='flex-1 text-center'>Leave a review</span>
    </DisablePrefetchLink>
  )
}